import { render } from "./BotSelectOption.vue?vue&type=template&id=f6821ed6"
import script from "./BotSelectOption.vue?vue&type=script&lang=js"
export * from "./BotSelectOption.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__